module.exports = __webpack_public_path__ + "img/P150T_weapon_7.8e4bd7c5.png";